<div class="asset-container">
    <div class="asset-card" (click)="onClick(asset)">
        <div class="asset-shadow"></div>
        <div class="asset-poster-container" [ngClass]="{'asset-poster-container-v': style == 'C'}">
            <img class="asset-poster lazyload"
                appLazyload="{{asset.images | getImage: (style == 'C' ? 'posters': 'thumbnails'):features.posterQuality}}"
                (error)="'assets/images/placeholders/placeholder_' + style + '.png'" appLazyPlaceholder="{{style}}" />
        </div>
        <p class="asset-title text-style">{{asset.title}}</p>
    </div>
    <i class="asset-award fa fa-medal" matTooltip="{{(asset.customParameters.award | jsonparser)[lang]}}"
        matTooltipClass="theme-tooltip text-style" *ngIf="asset?.customParameters?.award"></i>
</div>